<form #form="ngForm" novalidate>
    <sgt-loading-info
        *ngIf="isLoading"
        title="Carregando central de compras"
        text="Aguarde um momento enquanto estamos carregando a central de compras">
    </sgt-loading-info> 
   

    <ng-template [ngIf]="isLoaded && centralCompras">
        <div class="row">
            <div class="form-group col-12 col-sm">
                <label class="col-form-label" for="centralCompras">Central de Compras</label>
                <!-- <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{{centralCompras.codigoIntegracaoErp}}</span>
                    </div>
                </div> -->
                <input type="text" class="form-control" [value]="centralCompras.nome" disabled="disabled" readonly="readonly">
                <p class="form-text text-muted" *ngIf="centralCompras">
                    {{centralCompras.nomeFantasia}}
                </p>
            </div>
        </div> 

        <!-- Participantes -->
        <sgt-cliente-central-compra-participante-form
            #formParticipantes
            [(entities)]="centralCompras.participantes"
            [(percParticipacaoTotalCentralCompra)]="centralCompras.percParticipacaoTotal">
        </sgt-cliente-central-compra-participante-form>
    </ng-template>
</form>  